/*
 * menu.js — mobilní panel navigace.
 *
 * ZDROJ: skript v `navrh-kontakt.html` (tag `za-navrhy-v1.0`). Chování
 * je přeneseno 1:1; návrh je specifikace, ne inspirace.
 *
 * SKLÍZÍ SE NÁVRH, NE TERRAHUNT. Manifest vede `menu.js` (603 ř.) mezi
 * moduly k převzetí, ale ten obsluhuje JINÝ panel s jinou strukturou
 * a jiným chováním (víceúrovňové menu, vlastní focus trap). Náš návrh
 * chce třicet řádků: otevřít, zavřít, Escape, zamknout scroll. Přenést
 * 603 řádků kvůli třiceti by znamenalo nést kód bez konzumenta.
 *
 * ---------------------------------------------------------------------
 * ODCHYLKA PROTI NÁVRHU: `js` → `no-js`
 * ---------------------------------------------------------------------
 * Návrh přidává na `<html>` třídu `js` a CSS na ni váže zobrazení
 * hamburgeru. My máme opačnou konvenci: `no-js` sází PHP a odebírá ji
 * inline skript v `<head>` (`inc/assets-2026.php`). Důvod je blikání —
 * třída přidávaná až z externího souboru v patičce znamená, že stránka
 * na okamžik vykreslí bezJS variantu.
 *
 * Obě konvence řeší totéž. Nedrží se obě: `js` by se přidávala pozdě
 * a `no-js` už je na stránce dřív, než se tenhle soubor stáhne.
 */

const PANEL_ID = 'hpanel';
const OPEN_CLASS = 'panel-open';

/**
 * Spustí panel. Vrací počet inicializací (0 nebo 1) — stejná konvence
 * jako `carousel.js`, aby se dalo měřit, kolikrát modul proběhl.
 */
export function init() {
	const burger = document.querySelector('.hburger');
	const panel = document.getElementById(PANEL_ID);

	if (!burger || !panel) {
		return 0;
	}

	if (burger.dataset.za2026MenuInit === '1') {
		return 0;
	}
	burger.dataset.za2026MenuInit = '1';

	const toggle = (open) => {
		burger.setAttribute('aria-expanded', String(open));
		panel.hidden = !open;
		document.body.classList.toggle(OPEN_CLASS, open);

		/*
		 * Fokus se přesouvá do panelu a zpět na hamburger. Bez toho by
		 * klávesnicový uživatel po otevření zůstal stát na tlačítku
		 * a Tab by ho protáhl stránkou POD překryvem.
		 */
		if (open) {
			const first = panel.querySelector('a');
			if (first) {
				first.focus();
			}
		} else {
			burger.focus();
		}
	};

	burger.addEventListener('click', () => {
		toggle(burger.getAttribute('aria-expanded') !== 'true');
	});

	/*
	 * Klik na odkaz panel zavře. Delegace na kontejner, ne posluchač na
	 * každém odkazu: položek je šest a přibývají z menu, takže vázat je
	 * po jedné by znamenalo hlídat, kdy se seznam změní.
	 */
	panel.addEventListener('click', (e) => {
		if (e.target && e.target.tagName === 'A') {
			toggle(false);
		}
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !panel.hidden) {
			toggle(false);
		}
	});

	return 1;
}
